import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatFreightCode(code: number) {
  return `F-${code}`
}

export function formatRepaymentCode(code: number) {
  return `R-${code}`
}
